var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReunion = function SvgReunion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "reunion_svg__Capa_2",
    viewBox: "0 0 49.59 42.55"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reunion_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.33 15.81c0-2.18-1.77-3.95-3.95-3.95H10.21c-2.18 0-3.95 1.77-3.95 3.95v21.48h37.07z",
    fill: "#55ddd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.29v1.32c0 2.18 2.36 3.95 5.28 3.95h39.03c2.92 0 5.28-1.77 5.28-3.95v-1.32zM43.33 15.44v8.02c0 1.27-.85 2.43-2.11 2.69-1.69.34-3.19-.94-3.19-2.57v-.98c0-.72-.3-1.38-.78-1.85-.52-.52-1.25-.82-2.06-.76-1.41.09-2.46 1.34-2.46 2.74v4.93c0 1.27-.86 2.44-2.11 2.7a2.64 2.64 0 0 1-3.18-2.58V22.6c0-.72-.3-1.38-.78-1.85-.52-.52-1.25-.82-2.06-.76-1.41.09-2.46 1.34-2.46 2.74v1.25c0 1.27-.86 2.44-2.11 2.7a2.64 2.64 0 0 1-3.18-2.58v-.39c0-.73-.3-1.38-.78-1.86-.67-.65-1.68-.98-2.77-.63-1.06.34-1.75 1.38-1.75 2.49-.07 1.39-1.23 2.49-2.65 2.49s-2.64-1.17-2.64-2.62v-8.15c0-1.97 1.61-3.56 3.59-3.56h29.88c1.99 0 3.6 1.6 3.6 3.57",
    fill: "#22aa9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36 5.65c-.45-2.64-1.95-4.53-4.49-5.6h-.01a.6.6 0 0 0-.18-.03c-.28 0-.5.22-.5.5 0 .21.13.39.32.46 2.18.92 3.45 2.47 3.87 4.7a3.124 3.124 0 0 0-2.52 3.07c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13a3.12 3.12 0 0 0-2.73-3.09Z",
    fill: "#22aa9f"
  }))));
};
export default SvgReunion;